<div class="modal-content">
    <form (ngSubmit)="onSubmit()" #requestExport="ngForm">
        <div class="modal-header">
            <div class="modal-wizard-label">
                <div class="modal-wizard-title">Exportación de datos</div>
                <div class="modal-wizard-desc">Indique rango de fechas y tipo de exportación.</div>
            </div>
            <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group row mx-1">
                <div class="col-4 label-control pt-3">Rango de Fechas</div>
                <div class="col-6">
                    <input type="text" name="dateExportacion" [maxDate]="todayString" ngxDaterangepickerMd [locale]="locale" (change)="detectExportChangeDate($event)" (input)="detectExportChangeDate($event)" [(ngModel)]="dateExportacion" class="form-control" [singleDatePicker]="false" [autoApply]="true" [autocomplete]="false" [showDropdowns]="true" />
                    <div *ngIf="requestExport.submitted && (dateExportacion.startDate == null || dateExportacion == '' || !validDate)" class="invalid-feedback-group">
                        <div *ngIf="dateExportacion.startDate == null">Campo requerido</div>
                        <div *ngIf="!validDate && locale.format == 'MM/YYYY'">Fecha inválida, use el formato dd/mm/yyyy</div>
                    </div>
                </div>
                <div class="form-group row mx-1 mt-6">
                    <label class="col-6 label-control pt-3" for="exportType">Tipo de Exportación</label>
                    <div class="col-2 d-flex justify-content-between align-items-center">
                        <div class="form-check form-check-inline mr-6" >
                           <input type="radio" class="form-check-input" id="excelRadio" name="exportType" [value]="'excel'" [(ngModel)]="exportType" required>
                           <label class="form-check-label" for="excelRadio">Excel</label>
                        </div>
                        <!--
                        <div class="form-check form-check-inline mr-6" >
                           <input type="radio" class="form-check-input" id="pdfRadio" name="exportType" [value]="'pdf'" [(ngModel)]="exportType" required>
                           <label class="form-check-label" for="pdfRadio">PDF</label>
                        </div>-->
                        <div class="form-check form-check-inline mr-6" >
                           <input type="radio" class="form-check-input" id="xmlRadio" name="exportType" [value]="'xml'" [(ngModel)]="exportType" required>
                           <label class="form-check-label" for="xmlRadio">XML</label>
                        </div>
                    </div>
                </div>
                

            </div>
        </div>
        <div class="modal-footer d-flex align-items-center p-3">
            <div class="form-text text-muted mr-auto col-md-7">
                <p> El rango máximo permitido es de {{ isSuperAdmin ? '2 años' : '6 meses' }}, independiente de la fecha actual.</p>
            </div>
            <div>
                <button type="submit" id="add-contact-item" class="btn btn-success">
                    <i class="la la-paper-plane-o d-lg-none"></i>
                    <span class="d-none d-lg-block">Exportar</span>
                </button>
                <button type="button" class="btn btn-secondary ml-3" (click)="closeModal()">
                    <span class="d-none d-lg-block">Cerrar</span>
                </button>
            </div>
        </div>
    </form>
</div>